import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';


import Vue2Filters from 'vue2-filters'

Vue.use(Vue2Filters)

Vue.config.productionTip = true

Vue.use(require('vue-moment'));

Vue.config.subdomain = 'notism' 

Vue.prototype.$appBase = (Vue.config.productionTip) ? "https://www.gloopay.de"  : "http://www.gloopay.dd"; //"http://"+Vue.config.subdomain+".gloopay.dd/" 

Vue.prototype.$apiBase = Vue.prototype.$appBase + "/api"

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
